import { useMemo } from "react";
import { useQuery } from "react-query";

import { fetchMerchantSettings } from "~/api";
import { isPortalPreview } from "~/util/previewSession";

import { transformMerchantSettingsResponse } from "./useMerchantSettings.util";

export const MERCHANT_SETTINGS_QUERY_KEY = "merchantSettingsQuery";

// The query cache is persisted to sessionStorage, which the dashboard preview
// frame shares with a direct visit of the portal in the same tab. The preview
// keeps its own entry and always refetches, so unpublished state neither leaks
// into a regular visit nor goes stale between previews.
const previewQueryOptions = () =>
  isPortalPreview()
    ? { queryKey: [MERCHANT_SETTINGS_QUERY_KEY, "preview"], staleTime: 0 }
    : { queryKey: MERCHANT_SETTINGS_QUERY_KEY };

export const useMerchantSettings = () => {
  const { queryKey, ...queryOptions } = previewQueryOptions();
  const { data: response, ...restProps } = useQuery(
    queryKey,
    fetchMerchantSettings,
    queryOptions
  );
  const data = useMemo(
    () => transformMerchantSettingsResponse(response),
    [response]
  );
  return {
    data,
    ...restProps,
  };
};
